import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.iterator.js";
var SIZE_2_GB = 2 * 1024 * 1024 * 1024;
export default function isScormOrMicrosite(_x) {
  return _isScormOrMicrosite.apply(this, arguments);
}
function _isScormOrMicrosite() {
  _isScormOrMicrosite = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var _yield$import, jsZip, content, isMicrosite, isScorm, isValid, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return import(/* webpackChunkName: "jszip" */'jszip');
        case 1:
          _yield$import = _context.sent;
          jsZip = _yield$import.default;
          _context.prev = 2;
          _context.next = 3;
          return jsZip.loadAsync(file);
        case 3:
          content = _context.sent;
          isMicrosite = Boolean(content.file(/^(\/?[^/]*\/?index\.html)$/).length);
          isScorm = Boolean(content.file('imsmanifest.xml'));
          isValid = Boolean(isMicrosite || isScorm);
          return _context.abrupt("return", {
            file: file,
            isValid: isValid,
            isScorm: isScorm,
            isMicrosite: isMicrosite
          });
        case 4:
          _context.prev = 4;
          _t = _context["catch"](2);
          if (!(_t instanceof DOMException && _t.message.startsWith('The requested file could not be read') && file.size > SIZE_2_GB)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", {
            file: file,
            isValid: null
          });
        case 5:
          return _context.abrupt("return", {
            file: file,
            isValid: false
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 4]]);
  }));
  return _isScormOrMicrosite.apply(this, arguments);
}